import React from "react";

const ApplicationErrorLogsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13.9468V18.9468"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 23.9468H18.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M16.1401 8.94679L8.63009 22.4468C8.4756 22.7237 8.39423 23.0351 8.39381 23.3519C8.39338 23.6687 8.47391 23.9803 8.62765 24.2577C8.78138 24.535 9.00312 24.7686 9.27185 24.9359C9.54058 25.1032 9.84744 25.1985 10.1631 25.2128H25.1831C25.4987 25.1985 25.8056 25.1032 26.0743 24.9359C26.343 24.7686 26.5648 24.535 26.7185 24.2577C26.8722 23.9803 26.9528 23.6687 26.9524 23.3519C26.9519 23.0351 26.8706 22.7237 26.7161 22.4468L19.2061 8.94679C19.0475 8.67765 18.8213 8.45443 18.5501 8.29901C18.2788 8.1436 17.9719 8.06152 17.6591 8.06152C17.3463 8.06152 17.0394 8.1436 16.7681 8.29901C16.4969 8.45443 16.2707 8.67765 16.1401 8.94679Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ApplicationErrorLogsIcon;
